import { Box, styled, Typography } from '@mui/material';
import { mapSendingStatusToJobStatus } from 'features/myJobs';
import { JobApplicationListView } from 'features/myJobs/types';
import { formatSchedulePreviewRange } from 'pages/candidateOfferList';
import { useTranslation } from 'react-i18next';
import { useTenantContext } from 'shared/contexts';

import ProcessedOfferStatus from '../OfferDescription/ProcessedOfferStatus';

interface JobHistoryPreviewItemProps {
    job: JobApplicationListView;
}

export default function JobHistoryPreviewItem({ job }: JobHistoryPreviewItemProps) {
    const tenant = useTenantContext();
    const { t } = useTranslation('dates');

    const subtitle = [
        job.location,
        formatSchedulePreviewRange(job.dateStartUtc, job.dateEndUtc, tenant.timeZone, t)
    ].filter(Boolean).join(' • ');

    return (
        <Root>
            <span>
                <Typography variant="body2"
                    fontWeight="medium"
                >
                    { job.role }
                </Typography>
                { subtitle && (
                    <Typography variant="body2"
                        color="text.secondary"
                    >
                        { subtitle }
                    </Typography>
                ) }
            </span>

            <ProcessedOfferStatus status={ mapSendingStatusToJobStatus(job.status) } />

        </Root>   
    );
}

const Root = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
